export default __webpack_public_path__ + "static/media/sigma-ult.700e751b.mp3";